module.exports = __webpack_public_path__ + "img/icon_message.471dd681.png";